import React, { Component } from 'react'
import PropTypes from 'prop-types'
import GiveawaysEditor from './Tikex/GiveawaysEditor'

export default class Shortcode extends Component {
	render() {
		return <GiveawaysEditor />
	}
}

Shortcode.propTypes = {
	wpObject: PropTypes.object,
}
